import styled from 'styled-components/macro';
import { defaultContainer, colorByProp } from '../../../../styles/utils';
import { BlueStyledLink } from '../../../../components/LinkStyles';

export const CommissionsDiv = styled.div`
  ${defaultContainer}
  padding-top: 2rem;
  @media screen and (max-width: 767px) {
    padding: 0 5rem;
  }
  @media screen and (min-width: 768px) {
    display: flex;
  }
`;

export const CurrencyDetailDiv = styled.div`
  border-bottom: ${props => props.theme.defaultBorder};
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: center;
  padding: 2.5rem 0;
  @media screen and (min-width: 768px) {
    padding: 2rem 2rem;
    border-bottom: none;
    border-right: ${props => props.theme.defaultBorder};
  }
`;

export const CurrencyDetailSpacerDiv = styled.div`
  flex-basis: 150px;
  flex-grow: 1;
`;

export const RevenueShareH2 = styled.h2`
  font-size: 2.5rem;
  letter-spacing: 0.05rem;
  font-weight: 300;
  text-transform: unset;
`;

export const CurrencyNameH2 = styled.h2`
  font-size: 1.6rem;
  letter-spacing: 0.05rem;
  font-weight: 400;
  ${colorByProp}
  margin-bottom: 0.7rem;
  svg {
    transform: translateY(1px);
  }
`;
export const ViewMoreLinkDiv = styled.div`
  /* flex-grow: 1; */
  display: flex;
  align-items: center;
  @media screen and (min-width: 768px) {
    padding: 0 4rem;
  }
`;
export const ViewMoreLink = styled(BlueStyledLink)`
  font-weight: 600;
  letter-spacing: 0.03rem;
  @media screen and (max-width: 767px) {
    margin-top: 2rem;
    padding: 1rem 0;
  }
  @media screen and (min-width: 768px) {
    padding: 1rem;
  }
`;

export const NoCommissionDiv = styled.div`
  ${defaultContainer}
  padding-top: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  img {
    height: 100px;
  }
  p {
    margin-top: 15px;
    font-style: italic;
    color: ${props => props.theme.dustyGray};
  }
`;
